import React, { useState, useEffect, useRef, useCallback } from 'react';
// components/panels/SelectionPanel/SelectionPanel.jsx
import { useAnalyzeLayout } from "../AnalyzeLayoutContext";
import AssetFilter from "./AssetFilter";
import PeriodFilter from "./PeriodFilter";
import tenantService from "api/tenant.service";


// For Sliding Drawer
import SlidingDrawer from "components/sliding-drawer/SlidingDrawer";

import {
  Form as DxForm,
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule as DxFormRequiredRules
} from 'devextreme-react/form';
import TreeView from "devextreme-react/tree-view";
import AssetsService from 'api/assets.service';
import { addDays, addHours } from 'date-fns';
import DataSource from 'devextreme/data/data_source';
import { Toast } from 'components';




export default function SelectionPanel() {
  const { filters, setFilters } = useAnalyzeLayout();
  const [parsedSelectedAssets, setParsedSelectedAssets] = useState([]);
  const [openSections, setOpenSections] = useState(["Assets"]);
  const [tenantID, setTenantID] = useState();
  const [allAssets, setAllAssets] = useState();
  const [activeIcon, setActiveIcon] = useState(null);

  // for Sliding Drawer
  const [isOpen, setIsOpen] = useState(false);
  const [types, setTypes] = useState([])
  const [btnText, setBtnText] = useState("Select Date Range")
  const [state2, setState2] = useState([
    {
      startDate: addDays(new Date(), - 7),
      endDate: new Date(),
      key: 'selection',
    }
  ]);
  const [loadingText, setLoadingText] = useState('Loading assets...');
  const [formData, setFormData] = useState({});
  const [attributes, setAttributes] = useState([])
  const [prevData, setPrevData] = useState(null);
  const formRef = useRef(null);
  const dxFormRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [state3, setState3] = useState([
    {
      devicesId: [],
      devices: [],
      selectedRow: -1,
    }
  ]);
  const [devices, setDevices] = useState([])
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000,
  });

  const dataSource = new DataSource({
    store: [],
    key: 'id',
    searchMode: 'delay', // Use 'delay' mode for better user experience
    searchTimeout: 800, // Delay in milliseconds
  })

  const positionEditorOptions = {
    items: types,
    // items: [],
    searchEnabled: true,
    // value: '',
    // acceptCustomValue: false,
    displayExpr: "name",
    valueExpr: "id"
  };

  const deviceEditorOptions = {
    dataSource: devices,
    // dataSource: [],
    searchEnabled: true,
    // value: '',
    // acceptCustomValue: false,
    displayExpr: "serialNumber",
    valueExpr: "id",
  };

  useEffect(async() => {
    // dropDataGridRef.current.instance().clearSelection()
    await getAttributes();
    await getTypes();
    // Remove getDevices() call from here as it's only needed for editing
  }, []);

  function getTypes() {
    AssetsService.getAssetTenantTypes(tenantID).then((value) => {
      let response = value.data
      let names = []
      let namesId = []
      for (let i = 0; i < response?.data?.length; i++) {
        names.push({
          name: response.data[i].name,
          id: response.data[i].id
        })
        namesId.push(response.data[i].id)
      }
      setTypes(names)
    })
  }

  function appendAssetsData(newRecords){
    dataSource.store()._array = newRecords;
    console.log('reload 11');
    dataSource.reload();
  }

  function getAttributes() {
    AssetsService.getTenantAssetTypeAttributes(tenantID).then((value) => {
      let response = value?.data
      setAttributes(response?.data)
    })
  }

  useEffect(() => {
    const tenant = tenantService.getTenant();
    setTenantID(tenant);
    const stored = localStorage.getItem(
      `multiple-asset-selection-records-${tenant}`
    );
    const parsed = JSON.parse(stored || "[]");
    console.log("parsed:", parsed)
    setParsedSelectedAssets(parsed);
    setAllAssets(parsed)
    setFilters((prev) => ({ ...prev, selectedAssets: parsed, tenantID: tenant }));
  }, [setFilters]);

  async function getData(applyD, yes, reload) {
        if (dataSource._userData?.edit) return null;
        
        // Set loading state for initial data load
        if (yes === true) {
          setLoading(true);
        }
        let markers = []
        let from = null
        let to = null
        let to1 = null
        if (applyD === true) {
          from = state2[0].startDate
          to1 = state2[0].endDate
          to = addDays(to1, 1)
          localStorage.setItem(tenantID + "dateFilterFrom", from.toDateString())
          localStorage.setItem(tenantID + "dateFilterTo", to.toDateString())
          localStorage.setItem(tenantID + "dateFilterText", `${from.toDateString()} - 
          ${to1.toDateString()}`)
          setBtnText(`${from.toDateString()} - 
          ${to1.toDateString()}`)
        } else if (applyD === "inventory") {
          from = addHours(new Date(), -2)
          to = new Date()
          localStorage.setItem(tenantID + "dateFilterFrom", from.toDateString())
          localStorage.setItem(tenantID + "dateFilterTo", to.toDateString())
          localStorage.setItem(tenantID + "dateFilterText", "Inventory")
          setBtnText("Inventory")
        } else if ((localStorage.getItem(tenantID + "dateFilterFrom") !== null || localStorage.getItem(tenantID + "dateFilterFrom") !== "null") && applyD !== false) {
          from = Date.parse(localStorage.getItem(tenantID + "dateFilterFrom"))
          to = Date.parse(localStorage.getItem(tenantID + "dateFilterTo"))
          to1 = "test"
          let myBtnText = localStorage.getItem(tenantID + "dateFilterText")
          if (myBtnText !== null) {
            setBtnText(localStorage.getItem(tenantID + "dateFilterText"))
          }
        }
        else if (applyD === false) {
          from = null
          to = null
          setBtnText("Select Date Range")
        }
        if (yes === true) {
          try {
            const value = await AssetsService.getAssets(tenantID, null, null);
            let assets = value.data.data
            setLoadingText("No Data");
            if (markers.length !== 0) {
              let assetsToShow = assets.filter(asset => {
                return markers.find(marker => {
                  return marker === asset.id
                })
              })
              assetsToShow.forEach(obj => {
                const wearLevel = obj.attributes?.wear_level;
                // Check if wear_level is not null and cast it to an integer
                if (wearLevel !== null && wearLevel !== undefined) {
                    obj.attributes.wear_level = parseInt(wearLevel, 10);
                }
              });
              
              appendAssetsData(assetsToShow);
            } else {
              value.data.data.forEach(obj => {
                const wearLevel = obj.attributes?.wear_level;
                
                // Check if wear_level is not null and cast it to an integer
                if (wearLevel !== null && wearLevel !== undefined) {
                    obj.attributes.wear_level = parseInt(wearLevel, 10);
                }
              });
              appendAssetsData(value.data.data);
              localStorage.setItem(`total-assets-count-${tenantID}`, value.data.data.length);
              console.log('tootal aseets 1: ', value.data.data.length);
            }
            setLoading(false);
          } catch (error) {
            console.error('Error loading assets:', error);
            setLoading(false);
          }
        } else {
          getAttributes()
          // setData([])
        }
      }

  const handleAssetsChange = (assets) => {
    setFilters((prev) => ({ ...prev, selectedAssets: assets }));
    setParsedSelectedAssets(assets);
  };

  const handlePeriodChange = (period) => {
    setFilters((prev) => ({ ...prev, period }));
  };

  const toggleSection = (title) => {
    setOpenSections((prev) =>
      prev.includes(title)
        ? prev.filter((t) => t !== title)
        : [...prev, title]
    );
  };

  const leftIcons = [
    { icon: "dx-icon-edit", tooltip: "Edit", action: "edit" },
    { icon: "dx-icon-favorites", tooltip: "Pointer", action: "pointer" },
    { icon: "dx-icon-exportxlsx", tooltip: "ExportExcel", action: "excel" },
    { icon: "dx-icon-chart", tooltip: "Report", action: "report" },
    { icon: "dx-icon-undo", tooltip: "Undo", action: "undo" },
  ];

  async function editAsset(asset) {
    const rowData = asset;
    if (!rowData) return;
    setFormData({
      id: rowData.id,
      name: rowData.name,
      type: rowData.type?.id,
      pairedDevice: rowData.pairedDevice?.id ?? "null" // <-- this ensures "Unpaired" is selected if null
    });
    setPrevData({
      id: rowData.id,
      name: rowData.name,
      type: rowData.type?.id,
      pairedDevice: rowData.pairedDevice?.id ?? "null"
    });
    setLoading(true);
    setIsOpen(true);
    await getDevices(rowData.pairedDevice, null);
  }

  async function getDevices(currentDevice, row) {
      try {
        const value = await AssetsService.getAssetTagsToPair(tenantID);
        let response = value.data
        // let serials = []
        let serialsId = []
        let serials = [
          { serialNumber: "Unpaired", id: "null" }
        ];
        serialsId.push(null)
        if (currentDevice?.id && currentDevice?.serialNumber){
          serials.push({
            serialNumber: currentDevice.serialNumber,
            id: currentDevice.id
          })
        }
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].freeToPair) {
            serials.push({
              serialNumber: response.data[i].serialNumber,
              id: response.data[i].id
            })
            serialsId.push(response.data[i].id)
          }
        }
        // setState3({
        //   devicesId: serialsId,
        //   devices: serials,
        //   selectedRow: row,
        // })
        // setDevices(serials)
        // Ensure state update before rendering
        await new Promise(resolve => {
          setDevices([...serials]);  // Spread operator to trigger re-render
          setState3({
            devicesId: serialsId,
            devices: serials,
            selectedRow: row
          });
          resolve();
        });
        setLoading(false)
        if(currentDevice?.id){
          setIsOpen(true)
        }
      } catch (error) {
        console.error('Error fetching devices:', error);
        setLoading(false);
      }
    }

  const handleLeftIconClick = (action) => {
    setActiveIcon(action);
    switch (action) {
      case "edit":
        // const trueKeys = Object.keys(selectedAssetsData).filter(key => selectedAssetsData[key] === true);
        if (filters?.selectedAssets?.length === 1) {
          let singleAsset = filters.selectedAssets[0]
          if(singleAsset){
            editAsset(singleAsset)
          }
        } else {
          console.log("Either none or more than one true");
          // your "else" logic here
        }
        // Your custom edit handler here
        break;

      case "pointer":
        console.log("🖐 Pointer mode selected");
        break;
      case "excel":
        console.log("📤 Exporting to Excel...");
        break;
      case "report":
        console.log("📊 Generating report...");
        break;
      case "undo":
        console.log("↩️ Undo last action");
        break;
      default:
        console.warn("Unknown action:", action);
    }
  };


  // for SlidingDrawer

  const handleSubmit = useCallback(
        (e) => {
          e.preventDefault();
          const result = dxFormRef.current?.validate?.();
          if (result?.isValid) {
            if(formData && formData.id){
              onRowUpdate()
            }else{
              // onAddRow()
            }
            handleCloseDrawer();
          }
        },
        [formData, handleCloseDrawer]
  );

  function handleCloseDrawer(){
    // setEditingRow(null)
    setFormData({
      name: "",
      type: "",
      pairedDevice: ""
    })
    setIsOpen(false)
    // props.setIsAssetEdit(false)
  }

  const handleSave = () => {
    formRef.current?.requestSubmit(); // 🔥 trigger native submit
  };

  function onRowUpdate(e) {
    const { id, name, type, pairedDevice } = formData;
    let deviceId = null;
    if (pairedDevice && pairedDevice !== "null") {
      deviceId = pairedDevice;
    }
    setLoading(true);
    AssetsService.editAsset(id, name, type, deviceId).then((asset) => {
      console.log("UPDATE_asset:", asset)
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: asset?.status === 200 ? 'success' : 'error',
        status: asset?.data?.status || asset?.status,
        message: asset?.data?.message || asset?.message,
      });

      getData(null, true, false);
    }).catch((error) => {
      console.error('Error updating asset:', error);
      setLoading(false);
    });
  }



  const AccordionSection = ({ title, children }) => {
    const isOpen = openSections.includes(title);
    return (
      <div style={{ border: "1px solid #ddd", borderRadius: 8, marginBottom: 8 }}>
        <div
          onClick={() => toggleSection(title)}
          style={{
            cursor: "pointer",
            background: "#f8f8f8",
            padding: "10px 14px",
            fontWeight: 600,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{title}</span>
          <span style={{ fontSize: 18 }}>{isOpen ? "−" : "+"}</span>
        </div>
        {isOpen && <div style={{ padding: 10 }}>{children}</div>}
      </div>
    );
  };

  return (
    <>
    <div style={{ display: "flex", height: "100%", background: "#fff" }}>
      {/* Left icon strip */}
      <div
        style={{
          width: 45,
          background: "#fafafa",
          borderRight: "1px solid #ddd",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 10,
          gap: 10,
        }}
      >
        {leftIcons.map((item, i) => (
          <div
            key={i}
            title={item.tooltip}
            style={{
              cursor: "pointer",
              padding: 6,
              borderRadius: 8,
              transition: "background 0.2s",
              background: activeIcon === item.action ? "#ddd" : "transparent", // highlight
            }}
            onClick={() => handleLeftIconClick(item.action)} 
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "#eee")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <i className={`${item.icon}`} style={{ fontSize: "28px" }}></i>
          </div>
        ))}
      </div>

      {/* Scrollable filter content */}
      <div style={{ flex: 1, padding: 10, overflowY: "auto" }}>
        <AccordionSection title="Assets">
          <AssetFilter
            assets={allAssets}
            selected={filters.selectedAssets}
            // onChange={setSelectedAssets}
            onChange={(asst) => setFilters((prev) => ({ ...prev, selectedAssets: asst }))}
          />
        </AccordionSection>

        <AccordionSection title="Period">
          <PeriodFilter
            value={filters.period}
            onChange={handlePeriodChange}
          />
        </AccordionSection>
      </div>
    </div>

    <SlidingDrawer
      // title="Add Asset"
      title={`${formData?.id ? "Edit" : "Add"} Asset`}
      isOpen={isOpen}
      onClose={handleCloseDrawer}
      handleSave={handleSave}
      formData={formData}
      prevData={prevData}
    >
      {isOpen &&
      <form ref={formRef} onSubmit={handleSubmit}>
        <div>
          <DxForm
            formData={formData}
            onFieldDataChanged={(e) => {
              setFormData((prev) => ({
                ...prev,
                [e.dataField]: e.value,
              }));
            }}
            onInitialized={(e) => {
              dxFormRef.current = e.component;
            }}
            labelLocation="top"
            showColonAfterLabel={false}
            showValidationSummary={false}
          >
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="name"
                editorType="dxTextBox"
                editorOptions={{
                  valueChangeEvent: 'input',
                }}
                validationRules={[{ type: 'required', message: 'Name is required' }]}
              >
                <Label text="Name" isRequired />
              </SimpleItem>

              <SimpleItem
                dataField="type"
                editorType="dxSelectBox"
                editorOptions={{
                  items: positionEditorOptions?.items || [],
                  displayExpr: 'name',
                  valueExpr: 'id',
                  placeholder: 'Select...',
                  searchEnabled: true,
                  dropDownOptions: {
                    container: '.slide-pane'
                  },
                  itemRender: (item) => (
                    <div className="custom-item">
                      <div className="product-name">{item.name}</div>
                    </div>
                  ),
                }}
                validationRules={[{ type: 'required', message: 'Asset Type is required' }]}
              >
                <Label text="Asset Type" isRequired />
              </SimpleItem>

              <SimpleItem
                dataField="pairedDevice"
                editorType="dxSelectBox"
                editorOptions={{
                  items: deviceEditorOptions?.dataSource || [],
                  displayExpr: 'serialNumber',
                  valueExpr: 'id',
                  placeholder: 'Select a device',
                  // showClearButton: true,
                  searchEnabled: true,
                  dropDownOptions: {
                    container: '.slide-pane'
                  }
                }}
                validationRules={[{ type: 'required', message: 'Paired Device is required' }]}
              >
                <Label text="Paired Device" isRequired />
              </SimpleItem>
            </GroupItem>
          </DxForm>
        </div>
      </form>
      }
    </SlidingDrawer>

    <Toast
      setParentToastConfig={setToastConfig}
      toastBody={toastConfig}
      key={'toast'}
    />
    </>
  );
}
